import React, { useEffect, useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import { IColaboratorsPage } from "./types";
import { privilegeMap } from "./types";

const ColaboratorsPage = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [admins, setAdmins] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [privilege, setPrivilege] = useState(0);

  const localPrivilege = parseInt(localStorage.getItem("privilege") || "0");
  const canAddAdmin = localPrivilege === 1;

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("https://has-backend-c48d669d897f.herokuapp.com/getAdmin", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setAdmins(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar administradores:", error);
        setIsLoading(false);
      });
  }, [refreshTrigger]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    const token = localStorage.getItem("token");
    e.preventDefault();
    setMessage("");

    try {
      const response = await fetch("https://has-backend-c48d669d897f.herokuapp.com/admin/admin/register", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ name, email, password, role, privilege }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Registration failed");

      setMessage("Registration successful! Redirecting...");
      setRefreshTrigger((prev) => prev + 1);
      setShowPopup(false);

      setName("");
      setEmail("");
      setPassword("");
      setRole("");
      setPrivilege(0);
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  return (
    <div className="min-h-screen w-full px-4 sm:px-8">
      {canAddAdmin && (
        <div className="flex flex-col items-start gap-8">
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl mt-12">Acciones</h2>
          <button
            onClick={() => setShowPopup(true)}
            className="bg-[#1c1c2e] text-white font-sourceSans rounded-lg py-2 px-6 sm:w-[23%] w-full"
          >
            + Añadir
          </button>
        </div>
      )}

      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4">
          <div className="bg-[#d9d9d9] w-full sm:w-2/3 md:w-1/2 lg:w-1/3 p-6 rounded-lg shadow-lg relative">
            <button
              className="absolute top-2 right-4 text-gray-700 text-xl"
              onClick={() => setShowPopup(false)}
            >
              ×
            </button>
            <form onSubmit={handleSubmit} className="flex flex-col gap-2">
              <label className="font-sourceSans">Nombre Completo</label>
              <input
                className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 px-2"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <label className="font-sourceSans">Correo electrónico</label>
              <input
                className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 px-2"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label className="font-sourceSans">Contraseña</label>
              <input
                className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 px-2"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <label className="font-sourceSans">Nivel de privilegio</label>
              <select
                className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 px-2"
                value={privilege}
                onChange={(e) => setPrivilege(Number(e.target.value))}
                required
              >
                <option value="">Selecciona un nivel</option>
                <option value={1}>Administrador General</option>
                <option value={2}>Recepción</option>
                <option value={3}>Control Escolar</option>
              </select>
              <button
                className="bg-[#1c1c2e] text-white rounded-lg py-2 mt-6 font-sourceSans"
                type="submit"
              >
                Añadir Colaborador
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="flex flex-col items-start gap-4 mt-12">
        <h2 className="font-playfair font-bold text-3xl sm:text-4xl">Todos los colaboradores</h2>
        <div className="w-full flex flex-col">
          <div className="hidden sm:flex flex-row justify-between px-12 pb-4">
            <p className="font-sourceSans font-bold">Administrador</p>
            <p className="font-sourceSans font-bold">Rol</p>
          </div>

          {isLoading ? (
            <p>Cargando estudiantes...</p>
          ) : admins.length > 0 ? (
            admins.map((admin: IColaboratorsPage) => (
              <div
                key={admin._id}
                className="flex flex-col sm:flex-row justify-between border-y border-gray-600 py-2 px-4 sm:px-12 text-sm sm:text-base"
              >
                <a
                  onClick={() => navigate(`/admin/colaborators/${admin._id}`)}
                  className="text-[#2755ee] font-sourceSans cursor-pointer"
                >
                  {admin.name}
                </a>
                <p className="font-sourceSans mt-1 sm:mt-0">
                  {privilegeMap[admin.privilege] || "Sin privilegio"}
                </p>
              </div>
            ))
          ) : (
            <p>No hay administradores disponibles.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ColaboratorsPage;
